import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['collapse', 'backdrop'];

  connect() {
    this.collapseTarget.addEventListener('show.bs.collapse', this.showBackdrop);
    this.collapseTarget.addEventListener('hidden.bs.collapse', this.hideBackdrop);
  }

  disconnect() {
    this.collapseTarget.removeEventListener('show.bs.collapse', this.showBackdrop);
    this.collapseTarget.removeEventListener('hidden.bs.collapse', this.hideBackdrop);
  }

  showBackdrop = () => {
    this.backdropTarget.classList.add('show');
  }

  hideBackdrop = () => {
    this.backdropTarget.classList.remove('show');
  }
}
